/**
 * Prefix Google Calendar invite description with employer name.
 * @param {string} employerName
 * @param {string} descriptionBody - Existing invite HTML/text (due date line + body)
 */
export function withEmployerNameInInvite(employerName, descriptionBody) {
  const name = (employerName || '').trim() || 'Unknown'
  return `Employer name: ${name}\n\n${descriptionBody}`
}
